import React from "react";
import { formatNum } from "../../../constants";
import { useLanguageContext, useThemeContext } from "../../../context";
import Button from "../Button";

const AmountBox = ({
  subTotal,
  tax,
  order,
  givenPosDiscount,
  givenOrderDiscount,
  total,
}) => {
  const { theme } = useThemeContext();
  const { I18n } = useLanguageContext();

  console.log("givenPosDiscount", givenPosDiscount, givenOrderDiscount);

  return (
    <>
      <div className="amountDetailsBox">
        <div className="amountDetailsRow">
          <p>{I18n.sub_total}</p>
          <p>{`Rs. ${formatNum(subTotal || 0)}`}</p>
        </div>
        <div className="amountDetailsRow">
          <p>{I18n.total_tax}</p>
          <p>{`Rs. ${formatNum(tax || 0)}`}</p>
        </div>
        <div className="amountDetailsRow">
          <p>{I18n.discount}</p>
          <p>{`Rs. ${formatNum(
            Number(givenPosDiscount || 0) + Number(givenOrderDiscount || 0)
          )}`}</p>
        </div>
        <div
          className="amountDetailsRow"
          style={{
            borderBottom: `1px solid ${theme.darkgrayBorderbg}`,
          }}
        >
          <p>{I18n.bill_amount}</p>
          <p>{`Rs. ${formatNum(total || 0)}`}</p>
        </div>
        <div className="amountDetailsRow">
          <p>{I18n.paid_by_customer}</p>
          <p>{`Rs. ${formatNum(total + order?.change || 0)}`}</p>
        </div>
        <div className="amountDetailsRow">
          <p>{I18n.change}</p>
          <p>{`Rs. ${formatNum(order?.change || 0)}`}</p>
        </div>
      </div>
    </>
  );
};

export default AmountBox;
